import { Component, computed, inject } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { StructureSidebarService } from '../services/structure-service';
import { Articles, IResumeTips, ISidebarData } from '../interfaces/resume-tips';
import { ContentType } from '../interfaces/common-career';
import { FormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-career-structure',
  standalone: true,
  imports: [ RouterLink, RouterOutlet, FormsModule],
  templateUrl: './career-structure.html',
  styleUrls: ['./career-structure.scss']
})
export class CareerStructure {
  readonly ContentType = ContentType;
  private readonly router = inject(Router);
  private readonly structureService = inject(StructureSidebarService);
  private readonly translocoService = inject(TranslocoService);


  protected initStructureData = computed<ISidebarData | null>(() => this.structureService.SeconsidebarData());

  readonly showGoogleAd1 = computed(() => this.structureService.showGoogleAd1());
  readonly showWizardsAd = computed(() => this.structureService.showWizardsAd());
  readonly showGoogleAd2 = computed(() => this.structureService.showGoogleAd2());

  readonly categoryItems = computed(() => {
    const items = this.structureService.categoryNavItems();
    return Array.isArray(items) && items.length > 0 ? items : [];
  });

  readonly categoryHeader = computed(() => {
    const header = this.structureService.categoryHeader();
    return typeof header === 'string' && header.length > 0 ? header : '';
  });
 

 

  toggleArticle(item: Articles): void {
    if (item.type === 'article') {
      item.collapsed = !(item.collapsed ?? false);
      this.structureService.setCollapsed(item.articleHeader, item.collapsed);
     
    }
  }
  searchKeyword: string = '';
  onSearch(): void {
    this.router.navigate(['/jobs'], {
      queryParams: {
        qOT: '',
        txtsearch: this.searchKeyword,
        lang: 'en'
      }
    });
  }

  private readonly activeLang = toSignal(this.translocoService.langChanges$, {
    initialValue: this.translocoService.getActiveLang()
  });

  readonly sidebarData = computed(() => {
    const lang = this.activeLang();
    return lang === 'en' ? this.coverletterEnglish : this.coverletterBangla;
  });

  readonly sidebarHeader = computed(() =>
    this.activeLang() === 'en' ? 'Career Resource' : 'ক্যারিয়ার রিসোর্স'
  );

  private readonly coverletterEnglish: IResumeTips[] = [
    { type: 'tip', title: 'Interview Tips', url: '/career/interview' },
    { type: 'tip', title: 'Resume writing', url: '/career/resumewriting' },
    { type: 'tip', title: 'Cover Letter', url: '/career/cover_letter' },
    { type: 'tip', title: 'Articles', url: '/career/article' },
    { type: 'tip', title: 'CareerGuide', url: '/career/CareerGuide' },
  ];

  private readonly coverletterBangla: IResumeTips[] = [
    { type: 'tip', title: 'সাক্ষাৎকার টিপস', url: '/career/interview' },
    { type: 'tip', title: 'জীবনবৃত্তান্ত লিখন টিপস', url: '/career/resumewriting' },
    { type: 'tip', title: 'কভার লেটার', url: '/career/cover_letter' },
    { type: 'tip', title: 'প্রতিবেদন', url: '/career/article' },
    { type: 'tip', title: 'ক্যারিয়ার গাইড', url: '/career/CareerGuide' },
  ];
  
}